// extracted by mini-css-extract-plugin
export default {"container":"KP-z","title":"LP-z","link":"MP-z"};